export function formatGR(price: number): string {

    return Number(price).toLocaleString('el-GR',
        {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );
}